<div class="row mt-3">
  <div class="col-5 margin-auto">
    <file-upload [control]="fileUploadControl" class="upload"></file-upload>
  </div>
  <div class="col-5 margin-auto">
    <div class="d-flex">
      <mat-label class="col-6 margin-auto">Document Name </mat-label>
      <div class="col-6 file-list margin-auto">
        <div
          class="file-item"
          *ngFor="let file of fileUploadControl?.value"
          (click)="fileUploadControl.removeFile(file)"
        >
          {{ file.name }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <mat-label class="col-6 margin-auto">Document Type </mat-label>
      <div class="margin-auto col-6">
        <mat-form-field>
          <select matNativeControl required [(ngModel)]="selectedOption">
            <option
              *ngFor="let document of documentsList"
              [value]="document.code"
            >
              {{ document.name }}
            </option>
          </select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="col-2 margin-auto">
    <button mat-button (click)="upload()" type="submit">Upload</button>
  </div>
</div>

<div>
  <div class="table-responsive">
    <mat-form-field appearance="standard">
      <mat-label>Filter</mat-label>
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder="search with Employee id, name,.."
        #input
      />
    </mat-form-field>
    <div class="col text-left">
      <button (click)="refresh()" style="font-size: 24px" type="submit">
        <span class="material-icons">refresh</span>
      </button>
    </div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="documentId" sticky>
        <th mat-header-cell *matHeaderCellDef>Document Id</th>
        <td mat-cell *matCellDef="let element">{{ element?.documentId }}</td>
      </ng-container>

      <ng-container matColumnDef="category" sticky>
        <th mat-header-cell *matHeaderCellDef>{{ categoryDesc }}</th>
        <td mat-cell *matCellDef="let element" class="tab-col">
          {{ element?.category }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef>File Name</th>
        <td mat-cell *matCellDef="let element">{{ element?.fileName }}</td>
      </ng-container>

      <ng-container matColumnDef="documentDesc">
        <th mat-header-cell *matHeaderCellDef>Document Desc</th>
        <td mat-cell *matCellDef="let element">{{ element?.documentDesc }}</td>
      </ng-container>

      <ng-container matColumnDef="documentPath">
        <th mat-header-cell *matHeaderCellDef>Document Path</th>
        <td mat-cell *matCellDef="let element">{{ element.documentPath }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">{{ element.status }}</td>
      </ng-container>

      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef>Updated By</th>
        <td mat-cell *matCellDef="let element">{{ element?.updatedBy }}</td>
      </ng-container>

      <ng-container matColumnDef="updateDate">
        <th mat-header-cell *matHeaderCellDef>Updated Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.updateDate | date: "dd/MMM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            (click)="onDelete(element?.documentId, element?.documentPath)"
          >
            <mat-icon style="color: red">delete</mat-icon>
          </button>
          <button
            mat-icon-button
            (click)="onDownload(element?.fileName, element?.documentPath)"
          >
            <mat-icon style="color: blue">download</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
  <app-progress [loading$]="loading$"> </app-progress>
</div>
